// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yh1q","title":"styles_title__gSzI3"};